var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v(" All trademarks are properties of their respective owners. "+_vm._s(_vm.date)+" © Connaissant. All rights reserved ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }